// Additional endpoints for settings & branding — extends api.js
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_BASE = `${BACKEND_URL}/api`;
const KEY_ADMIN_TOKEN = 'fbx_admin_token';

const authed = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem(KEY_ADMIN_TOKEN)}` } });

export const brandingApi = {
  async get() {
    const { data } = await axios.get(`${API_BASE}/public/branding`);
    return data;
  },
  async categories() {
    const { data } = await axios.get(`${API_BASE}/public/categories`);
    return data.categories;
  },
};

export const settingsApi = {
  async getAll() {
    const { data } = await axios.get(`${API_BASE}/admin/settings`, authed());
    return data;
  },
  async updateSmtp(payload) {
    const { data } = await axios.put(`${API_BASE}/admin/settings/smtp`, payload, authed());
    return data;
  },
  async testSmtp(to) {
    const { data } = await axios.post(`${API_BASE}/admin/settings/smtp/test`, { to }, authed());
    return data;
  },
  async updateLogo(payload) {
    const { data } = await axios.put(`${API_BASE}/admin/settings/logo`, payload, authed());
    return data;
  },
  async updateCategories(categories) {
    const { data } = await axios.put(`${API_BASE}/admin/settings/categories`, { categories }, authed());
    return data;
  },
  async updateWatermark(payload) {
    const { data } = await axios.put(`${API_BASE}/admin/settings/watermark`, payload, authed());
    return data;
  },
};
